
<script type="text/ecmascript-6">
    import DesignerQuestionSelectSideGlassObscure from "../DesignerQuestionSelectSideGlassObscure.vue";

    export default {
        mixins: [
            DesignerQuestionSelectSideGlassObscure
        ],
        props: {
            backingGlass: {
                required: true,
            },
            solid_slab: {
              required: true,
            },
            slab: {
                required: true,
            }
        },
        computed: {
            backing_glass_required(){
                if(this.solid_slab) {
                  return Array.isArray(this.filtered_option_list) && this.filtered_option_list.length > 0;
                }
                return Array.isArray(this.filtered_option_list) && this.filtered_option_list.length > 1;
            },
            passed_filter(){
                if(this.solid_slab) {
                  return this.variable_ready(this.panelGlassId, this.sideVariant);
                }
                return this.variable_ready(this.panelGlassId, this.sideVariant, this.backingGlass);
            },
            option_filter(){
                if(this.solid_slab) {
                  return this.filtered_option_list.length > 0 && valid_selection;
                }
                return this.filtered_option_list.length > 0;
            },
            url(){
              return '/api/options/' + this.fabricator + '/side-glass-backing-design?panel_glass_id=' + this.panelGlassId + '&side_variant=' + this.sideVariant + '&backing_glass=' + this.backingGlass + '&slab=' + this.slab;
            },
            cache_key(){
              return '_' + this.panelGlassId + '_' + this.sideVariant + '_' + this.backingGlass + '_' + this.slab;
            },
        },
        watch: {
            'slab': function (val, oldVal) {
              if(this.solid_slab) {
                this.update_options();
              }
            },
            'backingGlass': function (val, oldVal) {
              if(!this.solid_slab) {
                this.update_options();
              }
            },
            'panelGlassId': function (val, oldVal) {
              if(this.solid_slab) {
                this.update_options();
              }
            },
            'sideVariant': function (val, oldVal) {
              if(this.solid_slab) {
                this.update_options();
              }
            },
        },
    }
</script>
